// Sticky category band that introduces every category section in the pricing
// matrix. Rendered as a single full-width table row that spans every column.
// `top` is set to match the size="small" sticky head row height so the band
// only begins to pin after the header (any larger value would cause it to
// overlap the first product row at scroll = 0).
import { TableRow, TableCell, Typography } from '@mui/material';

const STICKY_HEAD_HEIGHT_PX = 37;

const PricingCategoryRow = ({ name, columnCount }) => (
  <TableRow>
    <TableCell
      colSpan={columnCount}
      sx={{
        bgcolor: 'background.default',
        position: 'sticky',
        top: STICKY_HEAD_HEIGHT_PX,
        zIndex: 1,
        borderBottom: 1,
        borderColor: 'divider',
        py: 1.25,
      }}
    >
      <Typography variant="overline" component="span" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
        {name}
      </Typography>
    </TableCell>
  </TableRow>
);

export default PricingCategoryRow;
